// extracted by mini-css-extract-plugin
export default {"root":"VideoFormatForm_root__XIQWm"};